import React, { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Container, Link, Typography, styled } from '@mui/material';

import { setSeoMeta } from './seo';

const Paragraph = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  '&:last-of-type': {
    marginBottom: 0,
  },
}));

export default function Terms({ appName }) {
  const { t } = useTranslation();

  useEffect(() => {
    setSeoMeta({
      title: t('terms.seoTitle', { appName }),
      description: t('terms.seoDescription', { appName }),
    });
  }, [t, appName]);

  return (
    <Container maxWidth="md" sx={{ padding: 3 }}>
      <Paragraph>
        <Trans
          i18nKey="terms.p_apply"
          values={{ appName }}
          components={{ bold: <strong /> }}
        />
      </Paragraph>
      <Paragraph>{t('terms.p_unauthorized')}</Paragraph>
      <Paragraph>{t('terms.p_modify')}</Paragraph>
      <Paragraph>{t('terms.p_data')}</Paragraph>
      <Paragraph>{t('terms.p_thirdparty_intro')}</Paragraph>
      <Paragraph>
        <Trans i18nKey="terms.ai_lead" components={{ bold: <strong /> }} />
      </Paragraph>
      <Paragraph>{t('terms.p_ai_providers')}</Paragraph>
      <Paragraph>{t('terms.p_ai_accuracy')}</Paragraph>
      <Paragraph>{t('terms.p_ai_misuse')}</Paragraph>
      <Paragraph>{t('terms.p_ai_ownership')}</Paragraph>
      <Paragraph>{t('terms.p_ai_discontinue')}</Paragraph>
      <Paragraph>
        {t('terms.p_ai_links')}
        <ul>
          <li>
            <Link href="https://openai.com/policies/business-terms" target="_blank" rel="noopener noreferrer">
              {t('terms.link_openai_business')}
            </Link>
          </li>
          <li>
            <Link href="https://developers.google.com/terms" target="_blank" rel="noopener noreferrer">
              {t('terms.link_google_apis')}
            </Link>
          </li>
          <li>
            <Link href="https://ai.google.dev/gemini-api/terms" target="_blank" rel="noopener noreferrer">
              {t('terms.link_gemini')}
            </Link>
          </li>
        </ul>
      </Paragraph>
      <Paragraph>
        <Trans i18nKey="terms.analytics_heading" components={{ bold: <strong /> }} />
      </Paragraph>
      <Paragraph>
        <ul>
          <li>
            <Link href="https://amplitude.com/terms" target="_blank" rel="noopener noreferrer">
              Amplitude
            </Link>
          </li>
          <li>
            <Link href="https://superwall.com/legal/terms-of-service" target="_blank" rel="noopener noreferrer">
              Superwall
            </Link>
          </li>
          <li>
            <Link href="https://firebase.google.com/terms/crashlytics" target="_blank" rel="noopener noreferrer">
              Firebase Crashlytics
            </Link>
          </li>
          <li>
            <Link href="https://www.google.com/analytics/terms/" target="_blank" rel="noopener noreferrer">
              Google Analytics for Firebase
            </Link>
          </li>
        </ul>
      </Paragraph>
      <Paragraph>{t('terms.p_wifi')}</Paragraph>
      <Paragraph>{t('terms.p_mobile')}</Paragraph>
      <Paragraph>{t('terms.p_battery')}</Paragraph>
      <Paragraph>{t('terms.p_liability_intro')}</Paragraph>
      <Paragraph variant="subtitle1" component="p">
        {t('terms.limitation_title')}
      </Paragraph>
      <Paragraph>{t('terms.p_limitation')}</Paragraph>
      <Paragraph>{t('terms.p_updates')}</Paragraph>
      <Paragraph variant="subtitle1" component="p">
        {t('terms.changes_title')}
      </Paragraph>
      <Paragraph>{t('terms.p_changes')}</Paragraph>
      <Paragraph>{t('terms.effective')}</Paragraph>
      <Paragraph variant="subtitle1" component="p">
        {t('terms.contact_title')}
      </Paragraph>
      <Paragraph>{t('terms.p_contact')}</Paragraph>
    </Container>
  );
}
